import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_DAMAGE_WAIVER } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the Grip Marketplace Protection (Damage Waiver) line item in the order breakdown.
 *
 * @component
 * @param {Object} props
 * @param {Array}  props.lineItems - The line items array from the transaction
 * @param {Object} props.intl      - react-intl object (from injectIntl / useIntl)
 * @returns {JSX.Element|null}
 */
const LineItemDamageWaiverMaybe = props => {
  const { lineItems, intl } = props;

  const damageWaiverLineItem = lineItems?.find(
    item => item.code === LINE_ITEM_DAMAGE_WAIVER && !item.reversal
  );

  return damageWaiverLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.damageWaiver" />
      </span>
      <span className={css.itemValue}>
        {formatMoney(intl, damageWaiverLineItem.lineTotal)}
      </span>
    </div>
  ) : null;
};

export default LineItemDamageWaiverMaybe;
